import React from 'react';
import './PaymentTotalDue.css';
import { getPaymentTotalPrice } from 'Utils/PaymentTotalPrice';
import { getPaymentTotalDue } from 'Utils/PaymentTotalDue';
import { useStore } from 'Hooks/useStore';

export const PaymentTotalDue = () => {
  const promoCode = useStore('promoCode');
  const subscription = useStore('subscription');
  const { selectedPlan, selectedPlanPrice } = useStore('plans');
  const { totalTax } = useStore('checkout');

  const totalPrice = getPaymentTotalPrice({ selectedPlan, selectedPlanPrice, promoCode, totalTax });
  const totalDueLabel = getPaymentTotalDue({ subscription, selectedPlan, promoCode });

  return (
    <div className="paymentTotalDue">
      <span className="reviewLabel">{totalDueLabel}</span>
      <span className="reviewValue">${totalPrice}</span>
    </div>
  );
};
